export default __webpack_public_path__ + "static/media/service1.cd87189d.jpeg";